import React from 'react';
import {Dropdown} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import useProfileData from "@hooks/useProfileData";
import {getAccessState} from "@utils/helpers/access";
import {GAMES_PATH, REFUNDS_PATH} from "@constants/Paths";

const Header = () => {
    const navigate = useNavigate();
    const profile = useProfileData();
    const {hasGamesAccess, hasRefundAccess} = getAccessState();

    const handleLogout = () => {
        if (window.confirm('Are you sure you want to log out? The entered data will not be saved.')) {
            localStorage.clear();
            navigate("/login");
            window.dispatchEvent(new Event('storage'))
        }
    }
    return (
        <header>
            <div className="left-side">
                <svg width="50" height="40" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M34.3144 39.9998C33.3863 40.0046 32.4603 39.9092 31.5527 39.7153C29.7263 39.2684 27.9592 38.6074 26.288 37.7459L26.1918 37.6985L25.8816 28.7282L26.149 28.8599C29.9475 30.6936 32.9918 31.6263 35.197 31.6263C35.507 31.6272 35.8166 31.607 36.1238 31.5657C36.9044 31.4607 37.6564 31.202 38.3363 30.8045C39.0163 30.407 39.6106 29.8786 40.085 29.2498C40.5801 28.662 40.9467 27.977 41.1612 27.239C41.3758 26.501 41.4334 25.7262 41.3305 24.9646C41.2381 24.1609 40.9772 23.3857 40.5647 22.6897C40.1522 21.9937 39.5976 21.3926 38.9369 20.9257C37.7785 20.1323 36.3927 19.7391 34.9902 19.8059C34.7208 19.8059 34.4337 19.8158 34.134 19.8356C31.9683 19.9772 31.0949 20.0681 28.3318 20.3566C28.0848 21.6256 27.6778 22.8581 27.1205 24.0247C26.1181 26.2691 24.461 28.1584 22.3663 29.4448C20.4211 30.6506 18.2311 31.4067 15.9562 31.6579C15.4206 31.7136 14.8824 31.7417 14.3438 31.7422C11.0287 31.7514 7.82591 30.5413 5.34519 28.3422C2.29768 25.7246 0.411114 22.0064 0.0982896 18.0012C-0.128115 16.073 0.0375744 14.119 0.585405 12.2565C1.13323 10.394 2.0519 8.66145 3.28621 7.16294C4.46606 5.64209 5.94619 4.38023 7.63454 3.45583C9.32289 2.53143 11.1834 1.96426 13.1003 1.78958C13.6561 1.73154 14.2145 1.70208 14.7733 1.70132C19.1046 1.70132 22.7385 3.57916 25.5753 7.28347L25.6642 7.3994L21.707 11.9501L21.5753 11.767C20.7001 10.4976 19.5055 9.48153 18.112 8.82145C17.0996 8.35476 15.9993 8.10955 14.8846 8.10219C14.6272 8.10228 14.37 8.11547 14.1139 8.14171C13.0388 8.25042 11.998 8.58182 11.0579 9.11479C10.1178 9.64777 9.29904 10.3707 8.65364 11.2374C7.95515 12.091 7.43418 13.0755 7.12133 14.1332C6.80848 15.1908 6.71004 16.3003 6.83179 17.3966C6.92539 18.5317 7.244 19.6368 7.76904 20.6475C8.29409 21.6583 9.01507 22.5544 9.88995 23.2837C11.3289 24.5444 13.1763 25.2403 15.0894 25.2425C15.3937 25.242 15.6977 25.2262 16.0004 25.1951C17.2519 25.0607 18.4488 24.6106 19.4787 23.887C20.6235 22.9971 21.437 21.7492 21.7893 20.3427L15.0789 21.031L14.4657 15.0768L26.8031 13.8049L26.2155 2.57932L44.9004 0L45.8884 7.14713L34.7162 8.69037L34.8848 12.7741C35.6848 12.6691 36.4907 12.6152 37.2975 12.6127C40.1126 12.5248 42.8673 13.4404 45.0697 15.196C47.6528 17.2736 49.3292 20.2723 49.7462 23.561C50.01 25.4444 49.8725 27.3624 49.3427 29.189C48.813 31.0156 47.9029 32.7094 46.6722 34.1595C44.2359 37.2879 40.6601 39.3245 36.7265 39.824C35.9257 39.938 35.118 39.9968 34.3092 39.9998H34.3144Z"
                        fill="#F8F9FA"/>
                </svg>
                <label className="tabName">Store Admin Panel</label>
            </div>
            <div className="right-side">
                {profile &&
                    <Dropdown>
                        <Dropdown.Toggle
                            id="dropdown-basic"
                            className="user-dropdown"
                            drop="start"
                        >
                            {profile}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {hasGamesAccess &&
                                <Dropdown.Item
                                    as="button"
                                    className="dropdown-user-button"
                                    onClick={() => navigate(GAMES_PATH)}
                                >
                                    Games
                                </Dropdown.Item>
                            }
                            {hasRefundAccess &&
                                <Dropdown.Item
                                    as="button"
                                    className="dropdown-user-button"
                                    onClick={() => navigate(REFUNDS_PATH)}
                                >
                                    Refunds
                                </Dropdown.Item>
                            }
                            <Dropdown.Item
                                as="button"
                                className="dropdown-user-button"
                                onClick={handleLogout}
                            >
                                <span>Log out</span>
                                <span>
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M10 13C10 13.2761 9.77614 13.5 9.5 13.5L1.5 13.5C1.22386 13.5 1 13.2761 1 13L1 4C1 3.72386 1.22386 3.5 1.5 3.5L9.5 3.5C9.77614 3.5 10 3.72386 10 4L10 6C10 6.27614 10.2239 6.5 10.5 6.5C10.7761 6.5 11 6.27614 11 6L11 4C11 3.17157 10.3284 2.5 9.5 2.5L1.5 2.5C0.671574 2.5 4.95181e-07 3.17157 4.5897e-07 4L6.55671e-08 13C2.93554e-08 13.8284 0.671573 14.5 1.5 14.5L9.5 14.5C10.3284 14.5 11 13.8284 11 13L11 11C11 10.7239 10.7761 10.5 10.5 10.5C10.2239 10.5 10 10.7239 10 11L10 13Z"
                                          fill="#212529"/>
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M15.8536 8.85355C16.0488 8.65829 16.0488 8.34171 15.8536 8.14645L12.8536 5.14645C12.6583 4.95118 12.3417 4.95118 12.1464 5.14645C11.9512 5.34171 11.9512 5.65829 12.1464 5.85355L14.2929 8L5.5 8C5.22386 8 5 8.22386 5 8.5C5 8.77614 5.22386 9 5.5 9L14.2929 9L12.1464 11.1464C11.9512 11.3417 11.9512 11.6583 12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536L15.8536 8.85355Z"
                                          fill="#212529"/>
                                    </svg>
                                </span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                }
            </div>
        </header>
    );
};

export default Header;
